import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';
import Typography from '../Typography';
import style from './Navigation.module.scss';

type SubNavHeadingProps = {
  i18nKey: string;
};

const SubNavHeading: FC<SubNavHeadingProps> = ({ i18nKey }) => {
  const [t] = useTranslation('navbar');

  return (
    <ComponentWrapper>
      <Typography
        type="h4"
        size="overline"
        weight="semibold"
        className={style.subNavHeading}
      >
        {t(i18nKey)}
      </Typography>
    </ComponentWrapper>
  );
};

export default SubNavHeading;
